import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    user: {},
    token: "",
    pagePermission: {},
    fancyCounter: {},
    bookmakerCounter: {},
    parentIdList: [],
    formList: [],
    formWithPermission: {},
    sessionExpiresIn: "",
    sessionDetails: {},
  },
  reducers: {
    updateUser(state, action) {
      state.user = action.payload;
    },
    setToken(state, action) {
      state.token = action.payload;
    },
    setSessionExpiresIn(state, action) {
      state.sessionExpiresIn = action.payload;
    },
    clearUser(state) {
      state.user = {};
      state.token = "";
      state.pagePermission = {};
      state.sessionExpiresIn = "";
      state.sessionDetails = {};
    },
    setPagePermissions(state, action) {
      state.pagePermission = action.payload;
    },
    setFancyCounter(state, action) {
      state.fancyCounter = action.payload;
    },
    setBookmakerCounter(state, action) {
      state.bookmakerCounter = action.payload;
    },
    setParentIdList(state, action) {
      state.parentIdList = action.payload;
    },
    clearParentIdList(state) {
      state.parentIdList = [];
    },
    setFormList(state, action) {
      state.formList = action.payload;
    },
    setFormWithPermission(state, action) {
      state.formWithPermission = action.payload;
    },
    clearUserStore(state) {
      state.user = {};
      state.token = "";
      state.pagePermission = {};
      state.fancyCounter = {};
      state.bookmakerCounter = {};
      state.parentIdList = [];
      state.formList = [];
      state.formWithPermission = {};
      state.sessionExpiresIn = "";
      state.sessionDetails = {};
    },
    setSessionDetails(state, action) {
      state.sessionDetails = action.payload;
    },
  },
});

export const userAction = userSlice.actions;
export default userSlice;
